import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=a6d2062c&scoped=true&"
import script from "./SVGIcon.vue?vue&type=script&lang=js&"
export * from "./SVGIcon.vue?vue&type=script&lang=js&"
import style0 from "./SVGIcon.vue?vue&type=style&index=0&id=a6d2062c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d2062c",
  null
  
)

export default component.exports